import React, { useEffect, lazy, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';

// Lazy load page components for code splitting and faster initial load
const Moonyoga = lazy(() => import('./pages/Moonyoga'));
const Instruktoerer = lazy(() => import('./pages/Instruktoerer'));
const MoonGatherings = lazy(() => import('./pages/MoonGatherings'));
const PriserVilkaar = lazy(() => import('./pages/PriserVilkaar'));
const Holdplan = lazy(() => import('./pages/Holdplan'));
const Tilmeldingsbetingelser = lazy(() => import('./pages/Tilmeldingsbetingelser'));
const Handelsbetingelser = lazy(() => import('./pages/Handelsbetingelser'));
const Privatlivspolitik = lazy(() => import('./pages/Privatlivspolitik'));

// ScrollToTop component to ensure pages scroll to top or to hash anchor on navigation
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      setTimeout(() => {
        const elem = document.getElementById(id);
        if (elem) {
          elem.scrollIntoView({ behavior: 'smooth' });
        } else {
          window.scrollTo(0, 0);
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

// Elegant, lightweight loading fallback to prevent layout shifts
function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-[60vh] bg-brand-bg">
      <div className="flex flex-col items-center space-y-4">
        <div className="h-8 w-8 rounded-full border-2 border-brand-primary/20 border-t-brand-primary animate-spin" />
        <span className="text-xs tracking-widest uppercase text-brand-muted">Indlæser...</span>
      </div>
    </div>
  );
}

function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-brand-bg text-brand-text antialiased selection:bg-brand-primary/20 selection:text-brand-primary">
        {/* Header Navigation */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Moonyoga />} />
              <Route path="/instruktoerer" element={<Instruktoerer />} />
              <Route path="/moon-gatherings" element={<MoonGatherings />} />
              <Route path="/priser-vilkaar" element={<PriserVilkaar />} />
              <Route path="/holdplan" element={<Holdplan />} />
              <Route path="/tilmeldingsbetingelser" element={<Tilmeldingsbetingelser />} />
              <Route path="/handelsbetingelser" element={<Handelsbetingelser />} />
              <Route path="/privatlivspolitik" element={<Privatlivspolitik />} />
              
              {/* Fallback redirect or 404 route */}
              <Route path="*" element={<Moonyoga />} />
            </Routes>
          </Suspense>
        </main>

        {/* Footer with Contact Info & Navigation */}
        <Footer />
      </div>
    </>
  );
}

export default App;
